import { createContext } from 'react';

export const BreadcrumbContext = createContext({
    breadcrumbs:null,
    setBreadcrumbs: ()=>{}
});

